import { render, staticRenderFns } from "./AcademicDetails.vue?vue&type=template&id=9e5bb76a"
import script from "./AcademicDetails.vue?vue&type=script&lang=js"
export * from "./AcademicDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports